import { loadAfterTypingPause } from "../../../shared/loading/afterTypingPause";
import type { LoadState } from "../../../shared/loading/useLoad";
import { searchProcessItems, type ProcessSearchItem, type SearchKind } from "./processSearchApi";

export type SimilarSearchState = LoadState<readonly ProcessSearchItem[]>;

export function similarQuery(name: string, description: string): string {
  return `${name} ${description}`.trim().replace(/\s+/g, " ").slice(0, 1000);
}

/** Search once typing pauses; the returned stop cancels it. */
export function watchSimilarItems(projectId: string, query: string, kinds: readonly SearchKind[], receive: (state: SimilarSearchState) => void): () => void {
  return loadAfterTypingPause((signal) => searchProcessItems(projectId, query, kinds, signal), receive);
}
